export const notificationsLibrary = {
  /* заказ литературы */
  '01': 'Книга успешно добавлена',
  '02': 'Эта книга уже существует в заказе',
  '03': 'Книги успешно удалены из заказа',
  '04': 'Заказ книги успешно изменен',
  '05': 'Не удалось загрузить список',

  '06': 'Ошибка добавления книги в заказ',
  '07': 'Не удалось удалить заказ',
  '08': 'Заказ успешно удален',
  '09': 'Не удалось удалить книгу',
  '10': 'Не удалось добавить документ',

  '11': 'Документ успешно создан',
};
